import api from "../../../services/api";
import { gmapApi } from "vue2-google-maps";
import moment from "moment";
import formatcoords from "formatcoords";
import helpers from "../../../shared/fleetbox-helpers";
import { Marker, GeoPosition } from "../../../domain/poi";
import { bus } from "../../../main";

export default {
	components: {},
	props: {
		data: Array,
		zoom: { type: Number, default: 12 },
		isInEditMode: false,
		typeOfPoi: String,
		isNewOrEdit: { type: Boolean, default: false },
		pointToCenter: { type: Object, default: null }
	},
	data: function() {
		return {
			isCreated: false,
			firstTimeIn: true,
			center: {},
			markers: [],
			infoContent: "",
			infoWindowPos: null,
			infoWinOpen: false,
			currentMidx: null,
			infoOptions: {
				content: "",
				pixelOffset: {
					width: 0,
					height: -35
				}
			},
			paths: [],
			areas: [],
			edited: null,
			indexItem: 0,
			itemIsAlreadyAdded: false,
			
			mapStylesOptions: [ 
				{
					featureType: "poi",
					stylers: [ 
						{ 
							visibility: "off" 
						} 
					] 
				} 
			],
		};
	},
	watch: {
		pointToCenter: function(newValue) {
			if (newValue && newValue.lat && newValue.lng) {
				this.centerMap(newValue);

				this.$refs.map.$mapPromise.then(map => {
					if (map.getZoom() <= 14) {
						map.setZoom(15);
					}
				});
			}
		},
		isInEditMode: {
			handler() {
				this.itemIsAlreadyAdded = false;
			},
			deep: false
		},
		data: {
			handler() {
				this.displayMarkers();
			},
			deep: true
		}
	},
	created() {
		this.isCreated = true;
		this.center = {
			lat: 43.1107,
			lng: 12.3908
		};

		bus.$on("item-radius-change", this.onRadiusItemChange.bind(this));
		bus.$on("add-new-item", this.onAddNewItem.bind(this));
		bus.$on("on-selected-row", this.onSelectedRow.bind(this));
	},
	beforeDestroy() {
		bus.$off("item-radius-change");
		bus.$off("add-new-item");
		bus.$off("on-selected-row");
	},

	/* metodi */
	methods: {
		zoomChange() {
			this.$refs.map.$mapPromise.then(map => {
				console.log(map.getZoom());
			});
		},
		onSelectedRow(e) {
			if (e) {	
				var self = this;

				var bounds = new google.maps.LatLngBounds();

				var position = {};
				if (e.location && e.location.rendering_type) {
					if (e.location.rendering_type == "marker") {
						position = {
							lat: e.location.points[0].lat,
							lng: e.location.points[0].lon
						};

						bounds.extend(position);
					}
					if (e.location.rendering_type == "polygon") {
						e.location.points.forEach(p => {
							let pos = {
								lat: p.lat,
								lng: p.lon
							};
							
							if (pos.lat && pos.lng)
								bounds.extend(pos);
						});
					}
					if (e.location.rendering_type == "circle") {
						let circle = new google.maps.Circle({
							center: {
								lat: e.location.points[0].lat,
								lng: e.location.points[0].lon
							},
							radius: e.radius
						});
						
						bounds.union(circle.getBounds());
					}
				}
				else {
					position = {
						lat: e.location.points[0].lat,
						lng: e.location.points[0].lon
					};

					this.centerMap(position);
				}

				self.$refs.map.$mapPromise.then(map => {
					map.fitBounds(bounds);
					if (map.getZoom() >= 22) {
						map.setZoom(14);
					}
				});

				self.hideAllInfoWindow();
				self.markers.forEach(function(item, index) {
					if (item.id == e.id) {
						item.infoWindowOptions.infoWindowOpened = true;
					}
				});
				// self.paths.forEach(function(item, index) {
				// 	if (item.id == e.id) {
				// 		item.infoWindowOptions.infoWindowOpened = true;
				// 	}
				// });
				// self.areas.forEach(function(item, index) {
				// 	if (item.id == e.id) {
				// 		item.infoWindowOptions.infoWindowOpened = true;
				// 	}
				// });
			}
		},
		onAddNewItem() {
			this.itemIsAlreadyAdded = false;
		},
		onRadiusItemChange(item) {
			var itemArea = this.areas.find(f => {
				return f.id == item.id;
			});

			if (itemArea && item.radius) {
				itemArea.setRadius(item.radius);
			}
		},
		clearMarkers() {
			this.markers = [];
		},

		mapClickhandler(e) {
			if (this.isInEditMode) {
				switch (this.typeOfPoi) {
					case "marker":
						if (this.itemIsAlreadyAdded == false && this.isNewOrEdit) {
							var m = new google.maps.Marker();
							m.id = this.indexItem;
							m.draggable = true;
							var pos = {
								lat: e.latLng.lat(),
								lng: e.latLng.lng()
							};
							m.position = pos;
							m.title = `Nuovo POI`;

							this.indexItem--;

							this.$emit("new-marker", m);

							this.itemIsAlreadyAdded = true;
						}
						break;

					case "polygon":
						if (this.itemIsAlreadyAdded == false && this.isNewOrEdit) {
							var rectangle = this.drawRect(e.latLng, 500, 300, 500, 300, 0, 4, "#000000", 3, 1, "#ffffff", 1, {}, true);
							let paths = rectangle
								.getPath()
								.getArray()
								.map(function(p) {
									return {
										lat: p.lat(),
										lon: p.lng()
									};
								});

							paths.splice(paths.length - 1, 1);
							// Create Polygon
							var pathsToInsert = {
								id: this.indexItem,
								path: paths
							};
							this.indexItem--;

							this.$emit("new-polygon", pathsToInsert);
							this.itemIsAlreadyAdded = true;
						}
						break;
					case "area":
						if (this.itemIsAlreadyAdded == false && this.isNewOrEdit) {
							let radius = 100;
							let center = [
								{
									lat: e.latLng.lat(),
									lon: e.latLng.lng()
								}
							];

							// Create Polygon
							var areaToInsert = {
								id: this.indexItem,
								center: center,
								radius: radius
							};
							this.indexItem--;

							this.$emit("new-area", areaToInsert);
							this.itemIsAlreadyAdded = true;
						}
						break;
					default:
						break;
				}
			}
		},
		onMarkerDraged: function(e, id) {
			this.hideAllInfoWindow();
			this.$emit("edit-marker", {
				id: id,
				data: e
			});
		},
		onPathChanged: function(e, id) {
			let newPath = [];

			this.hideAllInfoWindow();

			for (let i = 0; i < e.getLength(); i++) {
				let point = e.getAt(i);
				newPath.push({
					lat: point.lat(),
					lng: point.lng()
				});
			}

			this.$emit("edit-polygon", {
				id: id,
				path: newPath
			});
		},
		onPathDragEnd: function(e, id) {
			this.hideAllInfoWindow();
			this.$emit("edit-polygon-end", {
				id: id
			});
		},
		onCircleCenterChange(e, id) {
			//this.hideAllInfoWindow();
			let center = [
				{
					lat: e.lat(),
					lon: e.lng()
				}
			];

			this.$emit("edit-area", {
				id: id,
				property: "center",
				center: center
			});
		},
		onCircleRadiusChange(e, id) {
			//this.hideAllInfoWindow();
			this.$emit("edit-area", {
				id: id,
				property: "radius",
				radius: e
			});
		},
		onCircleDragEnd(e, id) {
			this.hideAllInfoWindow();
			this.$emit("edit-area-end", {
				id: id
			});
		},
		handleClickForDelete(e) {
			if (e.vertex) {
				this.$refs.polygon.$polygonObject
					.getPaths()
					.getAt(e.path)
					.removeAt(e.vertex);
			}
		},
		displayMarkers: function() {
			var self = this;

			//items to remove - marker
			var itemsToRemove = [];
			for (let i = 0; i < this.markers.length; i++) {
				var m = this.markers[i];
				let dataItem = _.find(this.data, d => {
					return d.id == m.id;
				});

				if (!dataItem || dataItem.visible == false) itemsToRemove.push(m.id);
			}

			itemsToRemove.forEach(r => {
				let index = self.markers.findIndex(function(o) {
					return o.id == r;
				});

				self.markers.splice(index, 1);
			});

			//items to remove - polygon
			itemsToRemove = [];
			for (let i = 0; i < this.paths.length; i++) {
				var m = this.paths[i];
				let dataItem = _.find(this.data, d => {
					return d.id == m.id;
				});

				if (!dataItem || dataItem.visible == false) itemsToRemove.push(m.id);
			}

			itemsToRemove.forEach(r => {
				let index = self.paths.findIndex(function(o) {
					return o.id == r;
				});

				self.paths.splice(index, 1);
			});

			//items to remove - area
			itemsToRemove = [];
			for (let i = 0; i < this.areas.length; i++) {
				var m = this.areas[i];
				let dataItem = _.find(this.data, d => {
					return d.id == m.id;
				});

				if (!dataItem || dataItem.visible == false) itemsToRemove.push(m.id);
			}

			itemsToRemove.forEach(r => {
				let index = self.areas.findIndex(function(o) {
					return o.id == r;
				});

				self.areas.splice(index, 1);
			});

			var forceFitAndZoom = false;
			var minZoomValue = null;

			self.data.forEach(function(item, index) {
				if (item.visible) {
					if (item.location.rendering_type == "marker" || (item.location.rendering_type == "unknown" && item.location.points.length == 1)) {
						let m = _.find(self.markers, function(o) {
							return o.id == item.id;
						});

						if (m == null) {
							m = new google.maps.Marker();
							m.id = item.id;
							m.infoWindowOptions = {
								infoWindowOpened: false,
								pixelOffset: {
									width: 0,
									height: -40
								}
							};

							// google.maps.event.addListener(m, 'dragend', function(evt){
							// 	self.onMarkerDraged(evt);
							// });

							self.markers.push(m);

							forceFitAndZoom = true;
						}

						m.draggable = item.draggable;
						m.position = new GeoPosition(item.location.points[0].lat, item.location.points[0].lon);
						m.title = item.name;
						//m.info = "<b>" + item.name + "</b><br/>lat: " + item.location.points[0].lat + " lon: " + item.location.points[0].lon;
						m.info = `<b>${item.name}</b><br />
									  LAT: ${item.location.points[0].lat} - LON: ${item.location.points[0].lon}<br />
									  INDIRIZZO: ${item.location.address}<br />`;
						if (item.poi_category_icon_image && !self.isInEditMode) {
							var icon = {
								url: item.poi_category_icon_image,
								scaledSize: new google.maps.Size(30, 36), // scaled size
								origin: new google.maps.Point(0, 0) // origin
							};
							m.icon = icon;
						}
						m.infoWindowOptions.content = m.info;
					} else if (item.location.rendering_type == "polygon" || (item.location.rendering_type == "unknown" && item.location.points.length > 1)) {
						//marker related to polygon
						var allPoint = "";
						item.location.points.forEach(function(point) {
							allPoint += `lat: ${point.lat} - lon:${point.lon}<br />`;
						});
						if (!self.isInEditMode) {
							let m = _.find(self.markers, function(o) {
								return o.id == item.id;
							});

							if (m == null) {
								m = new google.maps.Marker();
								m.id = item.id;
								m.infoWindowOptions = {
									infoWindowOpened: false,
									pixelOffset: {
										width: 0,
										height: -40
									}
								};

								self.markers.push(m);
							}

							m.draggable = false;
							m.position = new GeoPosition(item.location.points[0].lat, item.location.points[0].lon);
							m.title = item.name;
							// m.info = `<b>${item.name}</b><br />${allPoint}`;
							m.info = `<b>${item.name}</b><br />
									  LAT: ${item.location.points[0].lat} - LON: ${item.location.points[0].lon}<br />
									  INDIRIZZO: ${item.location.address}<br />`;
							if (item.poi_category_icon_image) {
								var icon = {
									url: item.poi_category_icon_image,
									scaledSize: new google.maps.Size(30, 36), // scaled size
									origin: new google.maps.Point(0, 0) // origin
								};
								m.icon = icon;
							}
							m.infoWindowOptions.content = m.info;
						}

						//polygon
						let p = _.find(self.paths, function(o) {
							return o.id == item.id;
						});

						if (p == null) {
							p = {
								id: item.id,
								// path: item.location.points.map(function(pt) {
								// 	return new GeoPosition(pt.lat, pt.lon);
								// }),
								infoWindowOptions: {
									infoWindowOpened: false,
									pixelOffset: {
										width: 0,
										height: 0
									}
								}
							};

							self.paths.push(p);

							forceFitAndZoom = true;
						}
						if (!self.isInEditMode) {
							p.fillColor = item.poi_category_fill_color;
						}
						p.editable = item.editable;
						p.draggable = item.draggable;
						// var allPoint = "";
						// item.location.points.forEach(function(point) {
						// 	allPoint += `lat: ${point.lat} - lon:${point.lon}<br />`;
						// });
						(p.path = item.location.points.map(function(pt) {
							return new GeoPosition(pt.lat, pt.lon);
						})),
							(p.title = item.name);
						p.info = `<b>${item.name}</b><br />
									LAT: ${item.location.points[0].lat} - LON: ${item.location.points[0].lon}<br />
									INDIRIZZO: ${item.location.address}<br />`;
						p.infoWindowOptions.content = p.info;
					} else if (item.location.rendering_type == "circle") {
						//marker related to circle
						if (!self.isInEditMode) {
							let m = _.find(self.markers, function(o) {
								return o.id == item.id;
							});

							if (m == null) {
								m = new google.maps.Marker();
								m.id = item.id;
								m.infoWindowOptions = {
									infoWindowOpened: false,
									pixelOffset: {
										width: 0,
										height: -40
									}
								};

								self.markers.push(m);
							}

							m.draggable = item.draggable;
							m.position = new GeoPosition(item.location.points[0].lat, item.location.points[0].lon);
							m.title = item.name;
							//m.info = "<b>" + item.name + "</b><br/>lat: " + item.location.points[0].lat + " lon: " + item.location.points[0].lon;
							m.info = `<b>${item.name}</b><br />
									  LAT: ${item.location.points[0].lat} - LON: ${item.location.points[0].lon}<br />
									  INDIRIZZO: ${item.location.address}<br />`;
							if (item.poi_category_icon_image) {
								var icon = {
									url: item.poi_category_icon_image,
									scaledSize: new google.maps.Size(30, 36), // scaled size
									origin: new google.maps.Point(0, 0) // origin
								};
								m.icon = icon;
							}
							m.infoWindowOptions.content = m.info;
						}
						//area
						let a = _.find(self.areas, function(o) {
							return o.id == item.id;
						});

						if (a == null) {
							a = new google.maps.Circle();
							a.id = item.id;
							a.radius = item.radius;
							a.infoWindowOptions = {
								infoWindowOpened: false,
								pixelOffset: {
									width: 0,
									height: 0
								}
							};

							self.areas.push(a);

							forceFitAndZoom = true;
							minZoomValue = 16;
						}
						if (!self.isInEditMode) {
							a.fillColor = item.poi_category_fill_color;
						}
						a.center = new GeoPosition(item.location.points[0].lat, item.location.points[0].lon);

						(a.editable = item.editable), (a.draggable = item.draggable), (a.title = item.name);
						a.info = `<b>${item.name}</b><br />
									  LAT: ${item.location.points[0].lat} - LON: ${item.location.points[0].lon}<br />
									  INDIRIZZO: ${item.location.address}<br />`;
						a.infoWindowOptions.content = a.info;
					}
				}
			});

			if (forceFitAndZoom || this.isCreated) {
				self.fitAndZoom(minZoomValue);
				minZoomValue = null;
			}
		},
		fitAndZoom: function(minZoomValue) {
			this.isCreated = false;

			var self = this;

			var bounds = new google.maps.LatLngBounds();

			if (self.markers.length > 0 || self.paths.length > 0 || self.areas.length > 0) {
				self.markers.forEach(function(item, index) {
					bounds.extend(item.position);
				});
				self.paths.forEach(function(item, index) {
					item.path.forEach(p => {
						bounds.extend(p);
					});
				});
				self.areas.forEach(function(item, index) {
					bounds.extend(item.center);
				});

				self.$refs.map.$mapPromise.then(map => {
					map.fitBounds(bounds);
					if (map.getZoom() >= 22) {
						if (minZoomValue) map.setZoom(minZoomValue);
						else map.setZoom(14);
					}
				});
			} else {
				this.centerMap({
					lat: 46.07339415289572,
					lng: 13.22305560185896
				});
			}
		},
		markerClick: function(marker, idx) {
			this.$emit("onMarkerClick", { marker, idx });

			this.hideAllInfoWindow();

			this.toggleInfoWindow(marker);
		},
		hideAllInfoWindow: function() {
			var self = this;

			self.markers.forEach(function(item, index) {
				item.infoWindowOptions.infoWindowOpened = false;
			});

			self.paths.forEach(function(item, index) {
				item.infoWindowOptions.infoWindowOpened = false;
			});

			self.areas.forEach(function(item, index) {
				item.infoWindowOptions.infoWindowOpened = false;
			});
		},
		showAllInfoWindow: function() {
			var self = this;

			self.markers.forEach(function(item, index) {
				item.infoWindowOptions.infoWindowOpened = true;
			});
		},
		centerMap: function(position) {
			var self = this;

			self.$refs.map.$mapPromise.then(map => {
				map.setCenter(position);
			});
		},
		toggleInfoWindow: function(marker, idx) {
			marker.infoWindowOptions.infoWindowOpened = !marker.infoWindowOptions.infoWindowOpened;
		},
		drawRect: function(point, r1, r2, r3, r4, rotation, vertexCount, strokeColour, strokeWeight, Strokepacity, fillColour, fillOpacity, opts, tilt) {
			var rot = (-rotation * Math.PI) / 180;
			var points = [];
			var latConv = google.maps.geometry.spherical.computeDistanceBetween(point, new google.maps.LatLng(point.lat() + 0.1, point.lng())) * 10;
			var lngConv = google.maps.geometry.spherical.computeDistanceBetween(point, new google.maps.LatLng(point.lat(), point.lng() + 0.1)) * 10;
			var step = 360 / vertexCount || 10;

			var flop = -1;
			if (tilt) {
				var I1 = 180 / vertexCount;
			} else {
				var I1 = 0;
			}
			for (var i = I1; i <= 360.001 + I1; i += step) {
				var r1a = flop ? r1 : r3;
				var r2a = flop ? r2 : r4;
				flop = -1 - flop;
				var y = r1a * Math.cos((i * Math.PI) / 180);
				var x = r2a * Math.sin((i * Math.PI) / 180);
				var lng = (x * Math.cos(rot) - y * Math.sin(rot)) / lngConv;
				var lat = (y * Math.cos(rot) + x * Math.sin(rot)) / latConv;

				points.push(new google.maps.LatLng(point.lat() + lat, point.lng() + lng));
			}
			return new google.maps.Polygon({
				paths: points,
				strokeColor: strokeColour,
				strokeWeight: strokeWeight,
				strokeOpacity: Strokepacity,
				fillColor: fillColour,
				fillOpacity: fillOpacity
			});
		}
	},
	computed: {}
};
